import { MenuItem, Select, SxProps, Theme } from "@mui/material";
import { patternLink } from "theme/palette";

interface TextSelectOption {
  label: string;
  value: string | number;
}

interface TextSelectProps {
  options: TextSelectOption[];
  onChange: (event) => void;
  value: string | number;
  paddingLeft?: string;
  sx?: SxProps<Theme>;
}

const TextSelect = (props: TextSelectProps) => {
  const { options, onChange, value, paddingLeft, sx } = props;
  return (
    <Select
      value={value}
      onChange={onChange}
      displayEmpty
      sx={{
        ...{
          fontSize: "inherit",
          fontWeight: "inherit",
          color: patternLink,
          fieldset: {
            border: "none",
          },
          ".MuiSelect-outlined": {
            paddingY: 0,
            paddingLeft: paddingLeft || "6px",
            paddingRight: "28px!important",
          },
        },
        ...sx,
      }}>
      {options.map((o, index) => {
        return (
          <MenuItem title={o.label} key={index} value={o.value}>
            {o.label}
          </MenuItem>
        );
      })}
    </Select>
  );
};

export default TextSelect;
